import { render, staticRenderFns } from "./create-task.vue?vue&type=template&id=65468add&"
import script from "./create-task.vue?vue&type=script&lang=js&"
export * from "./create-task.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports